import ApplePayButton from '../apple-pay-button';
import ApplePayPaymentRequest = ApplePayJS.ApplePayPaymentRequest;
import store from '../../../../store/store';
import { APPLE_PAY_STORE_NAME } from './apple-pay.util';
import { ApplePayPaymentPayload } from '../interfaces/payment-method-data.interface';
import { StoreState } from '../../../../store/store.interface';
import { getApplePayInstance } from '../store/apple-pay.selectors';

export class ApplePaySessionUtil {
  /**
   * Creates and returns an Apple Pay session object.
   *
   * The session object contains different event handlers that are triggered during the payment process.
   *
   * @param request
   * @param component
   */
  createSession(request: ApplePayPaymentRequest, component: ApplePayButton): ApplePaySession | null {
    try {
      const state = store.getState() as StoreState;
      const session = new (window as any).ApplePaySession(3, request);

      session.onvalidatemerchant = (event) => {
        getApplePayInstance(state).performValidation({
          validationURL: event.validationURL,
          displayName: APPLE_PAY_STORE_NAME
        }).then((merchantSession) => {
          session.completeMerchantValidation(merchantSession);
        }).catch((validationErr) => {
          console.error('Error validating merchant:', validationErr);
          session.abort();
        });
      };

      session.onpaymentauthorized = (event) => {
        getApplePayInstance(state).tokenize({
          token: event.payment.token
        }).then((payload: ApplePayPaymentPayload) => {
          component.handlePaymentResponse(event, payload);
          session.completePayment((window as any).ApplePaySession.STATUS_SUCCESS);
        }).catch((tokenizeErr: any) => {
          console.error('Error tokenizing Apple Pay:', tokenizeErr);
          session.completePayment((window as any).ApplePaySession.STATUS_FAILURE);
        });
      };

      session.begin();
      return session;
    } catch (err) {
      console.error(`Error to complete the apple pay transaction result: ${(err as Error).message}`);
    }

    return null;
  }
}
